import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import SubpageShell from './SubpageShell';
import SEO from '../components/SEO';

const API = process.env.REACT_APP_BACKEND_URL;

export default function InfoPackUnsubscribe() {
  const [params] = useSearchParams();
  const [state, setState] = useState('working');
  useEffect(() => {
    const token = params.get('token');
    if (!token) { setState('invalid'); return; }
    axios.post(`${API}/api/academy/info-pack/unsubscribe`, { token }).then(() => setState('done')).catch(() => setState('invalid'));
  }, [params]);
  return (
    <SubpageShell currentPath="/academy/institutions">
      <SEO title="Follow-up emails — N3URO Academy" description="Manage School Info Pack follow-up emails." canonical="/academy/info-pack/unsubscribe" noindex />
      <main className="subpage-hero" data-testid="info-pack-unsubscribe">
        <span className="subpage-eyebrow">N3URO Academy</span>
        <h1 className="subpage-title">{state === 'done' ? 'You won’t get follow-ups.' : state === 'invalid' ? 'This link has expired.' : 'One moment…'}</h1>
        <p className="subpage-lede" role="status" data-testid="info-pack-unsubscribe-status">
          {state === 'done' && 'We’ve stopped School Info Pack follow-up emails to this address. You can still send an enquiry whenever you’re ready.'}
          {state === 'invalid' && 'We couldn’t find this request. If you keep receiving emails, write to hello@n3uro.world and we’ll sort it out.'}
          {state === 'working' && 'Updating your email preferences.'}
        </p>
        <Link to="/academy/institutions" className="service-enquiry-submit" style={{ display: 'inline-flex' }} data-testid="info-pack-unsubscribe-back"><span>Back to Schools &amp; Groups</span></Link>
      </main>
    </SubpageShell>
  );
}
